<template>
	<mu-col class="col-12">
		<center>
			<img class="content-image" :src="image_src" />
		</center>
	</mu-col>
</template>

<script>
export default {
	props: ['image_src']
};
</script>

<style>
.content-image{
  width: 65%;
  height: auto;
  border-radius: 15px;
}
</style>